<template>
	<div class="clock-view">
		<div class="hours">
			<div :class="'hour' + (_hours == i - 1 ? ' selected' : '')" v-for="i in 24" v-bind:key="'hours-' + i" @click="setHours(i - 1)">{{ (i - 1).toString().padStart(2, '0') }}</div>
		</div>
		<hr />
		<div class="minutes">
			<div :class="'minute' + (_minutes == (i - 1) * 5 ? ' selected' : '')" v-for="i in 12" v-bind:key="'minutes-' + i" @click="setMinutes((i - 1) * 5)">{{ ((i - 1) * 5).toString().padStart(2, '0') }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: [String, Number]
			}
		},
		computed: {
			_hours() {
				return parseInt(Math.floor(this.parseMinutes(this.value) / 60));
			},
			_minutes() {
				return parseInt(this.parseMinutes(this.value) % 60);
			}
		},
		methods: {
			setHours(hours) {
				this.$emit('input', this.parseValue(this.parseMinutes(this.value) - (this._hours - hours) * 60));
			},
			setMinutes(minutes) {
				this.$emit('input', this.parseValue(this.parseMinutes(this.value) - (this._minutes - minutes)));
			},
			parseMinutes(val) {
				if (!isNaN(val)) return val;

				var time = val.split(':');
				return parseInt(time[0]) * 60 + parseInt(time[1]);
			},
			parseValue($number) {
				if (isNaN(this.value)) {
					return Math.floor($number / 60).toString().padStart(2, '0') + ':' + ($number % 60).toString().padStart(2, '0');
				} else {
					return $number;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.clock-view {
		padding: 10px 0 10px 0;

		& > hr {
			border-top: 1px solid #CECECE;
			margin: 10px 0 10px 0;
		}

		& > .hours, & > .minutes {
			display: grid;
			grid-template-columns: repeat(6, 1fr);
			grid-column-gap: 6px;
			grid-row-gap: 6px;
			padding: 0 10px 0 10px;

			& > .hour, & > .minute {
				width: 32px;
				height: 32px;
				align-self: center;
				justify-self: center;
				text-align: center;
				line-height: 32px;
				border-radius: 50%;
				cursor: pointer;
				font-size: 12px;

				&.selected {
					background-color: #f7223f;
					color: white;
				}
			}
		}
	}
</style>